import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarMembresiaCliente } from '../../actions/clientes';

const EliminarMembresia = ({ membresia, reestablecerMembresia }) => {

    const dispatch =  useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Eliminar membresía */
    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(eliminarMembresiaCliente({
            id: membresia?.id_membresia, 
            id_cliente: membresia?.id_cliente
        }));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerMembresia(null);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if(membresia != null){
            setEliminarModal(true);
        }
    }, [membresia]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar membresía</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar la membresía {membresia?.nombre}{membresia?.fecha ? ' del ' + new Date(membresia?.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : '' }?</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarMembresia;